import ChevronDown from "../../../shared/svg/chevron-down";

interface ClickableBatchProps {
  onClick?: () => void;
  text: string;
}
const ClickableBatch = (props: ClickableBatchProps) => {
  return (
    <div
      className="clickable-batch--container"
      onClick={(e) => {
        e.stopPropagation();
        props.onClick?.();
      }}
    >
      <div className="clickable-batch--text">{props.text}</div>
      <div className="clickable-batch--icon">
        <ChevronDown />
      </div>
    </div>
  );
};

export default ClickableBatch;
